export const getDeviceInfo = () => {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;
  const language = navigator.language;
  const screenResolution = `${window.screen.width}x${window.screen.height}`;
  const colorDepth = window.screen.colorDepth;
  const cpuCores = navigator.hardwareConcurrency || '';
  const deviceMemory = navigator.deviceMemory || '';
  const maxTouchPoints = navigator.maxTouchPoints || '';
  // Canvas Fingerprinting
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  let canvasFingerprint = '';
  if (ctx) {
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('https://example.com', 2, 15);
    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
    ctx.fillText('https://example.com', 4, 17);
    canvasFingerprint = canvas.toDataURL();
  }

  return {
    userAgent,
    platform,
    language,
    screenResolution,
    colorDepth,
    cpuCores,
    deviceMemory,
    maxTouchPoints,
    canvasFingerprint,
  };
};
